import React, { useState } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import Fab from '@material-ui/core/Fab';
import ImageModal from 'Components/ImageModal';

function Preview({ files, onClickRemoveFile, isFullPreviewSupported, fullScreen }) {
  const [modalPreviewInformation, setModalPreviewInformation] = useState({});

  const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginRight: 40,
    marginTop: 30,
    padding: 4,
    boxSizing: 'border-box',
  };

  const thumbInner = {
    display: 'flex',
    minWidth: 0,
    position: 'relative',
    justifyContent: 'flex-start',
  };

  let img = {
    maxWidth: '150px',
    height: 'auto',
  };

  if (isFullPreviewSupported) {
    img = {
      ...img,
      cursor: 'pointer',
    };
  }

  const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 15,
    paddingTop: 0,
    alignItems: 'center',
  };

  const removeBtn = {
    position: 'absolute',
    top: -20,
    right: -20,
  };

  const icon = {
    height: '17px',
  };

  function onClickPreviewImage(file) {
    if (isFullPreviewSupported) {
      setModalPreviewInformation({
        imgSrc: file.base64,
        fileName: file.name,
      });
    }
  }

  return (
    <>
      {files.length > 0 && (
        <aside style={thumbsContainer}>
          {files.map((file, index) => (
            <div style={thumb} key={`${file.name}-${index}`}>
              <div style={thumbInner}>
                <img src={file.base64} style={img} alt="thumbnail" onClick={() => onClickPreviewImage(file)} />
                <Fab size="small" color="primary" onClick={() => onClickRemoveFile(file.name)} style={removeBtn}>
                  <DeleteIcon style={icon} />
                </Fab>
              </div>
            </div>
          ))}
        </aside>
      )}

      <ImageModal
        modalImageInformation={modalPreviewInformation}
        onClickCloseModal={() => setModalPreviewInformation({})}
        maxWidth="lg"
      />
    </>
  );
}

export default Preview;
